"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const Icon_1 = __importDefault(require("../Icon"));
const Sidebar = (props) => {
    react_1.useEffect(() => {
        const closeSidebarOnMouseClick = (e) => {
            const target = e.target;
            if (target.closest('.icon-with-hover-text-sidebar') === null) {
                props.closeSidebar();
            }
        };
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                props.closeSidebar();
                const button = document.activeElement;
                if (button) {
                    button.blur();
                }
            }
        };
        document.addEventListener('click', closeSidebarOnMouseClick);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('click', closeSidebarOnMouseClick);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (React.createElement("div", { className: "icon-with-hover-text-sidebar-container" },
        React.createElement("div", { className: "icon-with-hover-text-sidebar" },
            React.createElement("div", { className: "close-button", onClick: props.closeSidebar },
                React.createElement(Icon_1.default, { icon: "cross_purple" })),
            React.createElement("div", null, props.text))));
};
exports.Sidebar = Sidebar;
//# sourceMappingURL=Sidebar.js.map